var _g, _line, _g2, _g3, _line2, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCeilingToFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 565.1 619",
    enableBackground: "new 0 0 565.1 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 23.5,
    y1: 31.2,
    x2: 23.5,
    y2: 592.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "14.5,33.8 23.5,18.3 32.5,33.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "14.5,589.7 23.5,605.3 32.5,589.7  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 607.4,
    x2: 480,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M504.1,610.4v-12h7.9v1.3h-6.4v3.9h6.2v1.3h-6.2v5.5H504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513.8,610.4v-12h1.5v10.7h5.6v1.3H513.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M523.2,607.6c-0.5-0.9-0.7-2-0.7-3.2s0.2-2.2,0.7-3.2s1.2-1.7,2.1-2.2c0.9-0.5,1.9-0.8,3.1-0.8 s2.2,0.3,3.1,0.8c0.9,0.5,1.6,1.3,2.1,2.2c0.5,0.9,0.7,2,0.7,3.2s-0.2,2.2-0.7,3.2c-0.5,0.9-1.2,1.7-2.1,2.2 c-0.9,0.5-2,0.8-3.1,0.8s-2.2-0.3-3.1-0.8C524.4,609.3,523.7,608.6,523.2,607.6z M524,604.5c0,0.9,0.2,1.8,0.5,2.5 c0.4,0.7,0.9,1.3,1.5,1.7c0.7,0.4,1.5,0.6,2.3,0.6s1.7-0.2,2.3-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.5-1.6,0.5-2.5 c0-1.4-0.4-2.6-1.2-3.5c-0.8-0.9-1.9-1.4-3.2-1.4c-1.3,0-2.4,0.5-3.2,1.4S524,603,524,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M536.9,607.6c-0.5-0.9-0.7-2-0.7-3.2s0.2-2.2,0.7-3.2s1.2-1.7,2.1-2.2c0.9-0.5,1.9-0.8,3.1-0.8 s2.2,0.3,3.1,0.8c0.9,0.5,1.6,1.3,2.1,2.2c0.5,0.9,0.7,2,0.7,3.2s-0.2,2.2-0.7,3.2c-0.5,0.9-1.2,1.7-2.1,2.2 c-0.9,0.5-2,0.8-3.1,0.8s-2.2-0.3-3.1-0.8C538.1,609.3,537.4,608.6,536.9,607.6z M537.7,604.5c0,0.9,0.2,1.8,0.5,2.5 c0.4,0.7,0.9,1.3,1.5,1.7c0.7,0.4,1.5,0.6,2.3,0.6s1.7-0.2,2.3-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.5-1.6,0.5-2.5 c0-1.4-0.4-2.6-1.2-3.5c-0.8-0.9-1.9-1.4-3.2-1.4c-1.3,0-2.4,0.5-3.2,1.4S537.7,603,537.7,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M550.4,610.4v-12h4.8c1.1,0,2,0.3,2.7,1c0.7,0.7,1.1,1.5,1.1,2.6c0,0.5-0.1,1-0.3,1.4 c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.6,0.5-1,0.7s-0.8,0.3-1.2,0.3l3.2,4.9h-1.8l-3-4.7h-2.4v4.7H550.4z M551.9,604.4h3.1 c0.7,0,1.3-0.2,1.7-0.6s0.7-1,0.7-1.7s-0.2-1.2-0.7-1.7s-1-0.6-1.7-0.6h-3.1V604.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 16.9,
    x2: 480,
    y2: 16.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M496,16.2c-0.3-0.8-0.5-1.6-0.5-2.5s0.2-1.7,0.5-2.5s0.8-1.4,1.3-2c0.5-0.5,1.2-1,2-1.3s1.6-0.5,2.4-0.5 c1.9,0,3.4,0.8,4.6,2.4l-1.2,0.7c-0.4-0.5-0.8-1-1.4-1.3s-1.2-0.5-1.9-0.5c-1.3,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.3,2.1-1.3,3.5 c0,0.9,0.2,1.8,0.6,2.5c0.4,0.7,1,1.3,1.7,1.7c0.7,0.4,1.5,0.6,2.4,0.6c0.7,0,1.3-0.2,1.9-0.5s1.1-0.7,1.4-1.3l1.3,0.7 c-1.2,1.6-2.7,2.4-4.6,2.4c-0.9,0-1.7-0.2-2.4-0.5s-1.4-0.7-2-1.3C496.7,17.7,496.3,17,496,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M508.1,19.7v-12h7.9V9h-6.4v3.9h6.2v1.3h-6.2v4.1h6.4v1.3H508.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M518.4,19.7v-12h1.5v12H518.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M522.5,19.7v-12h1.5v10.7h5.6v1.3H522.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M531.5,19.7v-12h1.5v12H531.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M535.8,19.7v-12h1.5l6.9,9.4V7.7h1.5v12h-1.4l-7-9.6v9.6H535.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M548.6,16.3c-0.3-0.8-0.5-1.6-0.5-2.5c0-0.9,0.2-1.8,0.5-2.5c0.3-0.8,0.8-1.4,1.3-2c0.6-0.5,1.2-0.9,2-1.2 c0.8-0.3,1.6-0.4,2.4-0.4c1.9,0,3.5,0.7,4.7,2.2l-1.2,0.8c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.3-1.3-0.4-2-0.4c-1.3,0-2.4,0.5-3.3,1.4 c-0.9,0.9-1.3,2.1-1.3,3.5c0,0.9,0.2,1.8,0.6,2.5c0.4,0.8,1,1.3,1.7,1.7c0.7,0.4,1.5,0.6,2.4,0.6c0.7,0,1.3-0.1,1.9-0.4 c0.6-0.3,1-0.6,1.4-0.9v-2.4h-4.1v-1.3h5.6v4.3c-0.6,0.6-1.3,1.2-2.1,1.5c-0.8,0.4-1.7,0.6-2.6,0.6c-0.8,0-1.7-0.2-2.4-0.5 c-0.8-0.3-1.4-0.7-2-1.3S548.9,17,548.6,16.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.3,
    y: 78.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 425.3,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.6,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingToFloor);
export default __webpack_public_path__ + "static/media/CeilingToFloor.d09a5f06416e4fbaed446c173c7e0da9.svg";
export { ForwardRef as ReactComponent };